import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';
// import { register } from 'swiper/element/bundle';
// register();
if (environment.production) {
  (window as any).__assetPrefix__ = '/assets/ezy_flow/ezy_flow_frontend/browser/';

  // Monkey-patch createElement to rewrite <img src="assets/...">
  const originalSetAttribute = Element.prototype.setAttribute;
  Element.prototype.setAttribute = function (name: string, value: string) {
    if (name === 'src' && typeof value === 'string' && value.startsWith('assets/')) {
      value = (window as any).__assetPrefix__ + value;
    }
    return originalSetAttribute.call(this, name, value);
  };
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
